export function getUpdatesToApply(state, currentTime) {
  const currentElapsed = currentTime - state.start - state.idle.total
  const { elapsed, updates } = state

  return {
    // TODO :: optimize
    updates: updates.filter((update) => {
      if (elapsed === 0 && update.timestamp === 0) return true

      return elapsed < update.timestamp && update.timestamp <= currentElapsed
    }),
    elapsed: currentElapsed
  }
}

export function getDocUpdatesRetrospectively(state, docId) {
  return state.updates.filter((u) => {
    return u.doc === docId && u.timestamp <= state.elapsed
  })
}

export function nextFrame() {
  return new Promise((resolve) => {
    requestAnimationFrame((now) => {
      resolve(now)
    })
  })
}

/**
 * @ref https://gist.github.com/addyosmani/5434533
 * @param {*} fn callback function
 * @param {*} fps desired fps
 * @returns
 */
export function requestAnimationFrameByFps(fn, fps) {
  let then = Date.now()
  let stopped = false

  // custom fps, otherwise fallback to 60
  fps = fps || 60
  let interval = 1000 / fps

  return (function loop(perciseTime) {
    if (stopped) return
    requestAnimationFrame(loop)

    let now = Date.now()
    let delta = now - then

    if (delta > interval) {
      // Update time
      // now - (delta % interval) is an improvement over just
      // using then = now, which can end up lowering overall fps
      then = now - (delta % interval)

      // call the fn
      if (!fn(perciseTime)) {
        stopped = true
      }
    }
  })(0)
}
